<template>
  <Button v-bind="$attrs" class="elsa-primary-button">
    <slot />
  </Button>
</template>

<script>
import Button from "./Button";

export default {
  name: "PrimaryButton",
  components: {
    Button
  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/colors";

.elsa-primary-button.el-button {
  border-radius: 8px;
  padding: 0 10px;
  font-family: "SF Pro Display", sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #ffffff;
  height: 56px;

  &:disabled,
  &:disabled:hover,
  &:disabled:focus {
    background: rgba(109, 122, 140, 0.18);
    color: $white;
    border: none;
  }

  &.bigger {
    width: 202px;
  }

  &{
    background-color: $background-primary-button;
  }

  &:active,
  &:focus,
  &:hover
  {
    box-sizing: border-box;
    color: $white;
    background-color: $background-primary-button-hover;
    // background: linear-gradient(180deg, #29f4ff -46.11%, #5257ff 151.97%);
  }
}
</style>
